import { render, staticRenderFns } from "./PwaInstallTop.vue?vue&type=template&id=67764c6a&scoped=true&"
import script from "./PwaInstallTop.vue?vue&type=script&lang=js&"
export * from "./PwaInstallTop.vue?vue&type=script&lang=js&"
import style0 from "./PwaInstallTop.vue?vue&type=style&index=0&id=67764c6a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67764c6a",
  null
  
)

export default component.exports